import { createApp } from "vue"
import SignupMultipleNewsletters from "./SignupMultipleNewsletters"
import isBoolean from "../../../../../Frontend/src/foundation/js/inputValidators/isBoolean"
import { VueReCaptcha } from 'vue-recaptcha-v3'

const el = ".nyk-component--signup-multiple-newsletters"

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM.length) {
        DOM.forEach((SignupMultipleNewslettersDOM) => {
            const newsletters = SignupMultipleNewslettersDOM.dataset.newsletters
                ? JSON.parse(SignupMultipleNewslettersDOM.dataset.newsletters)
                : []
            const labels = JSON.parse(SignupMultipleNewslettersDOM.dataset.labels)
            const recaptchaSiteKey = SignupMultipleNewslettersDOM.dataset.recaptchaSiteKey;
            const antiForgeryToken = SignupMultipleNewslettersDOM.dataset.antiForgeryToken;
            const formId = SignupMultipleNewslettersDOM.dataset.formId
            const formTypeName = SignupMultipleNewslettersDOM.dataset.formTypeName
            const apiUrl = SignupMultipleNewslettersDOM.dataset.apiUrl
            const enableUserTrack = SignupMultipleNewslettersDOM.dataset.enableUserTrack ? JSON.parse(SignupMultipleNewslettersDOM.dataset.enableUserTrack) : false
            const newslettersUserInputs = newsletters.map((newsletter) => {
                return {
                    field: newsletter.name,
                    value: false,
                    validator: isBoolean,
                    isValid: false,
                }
            })

            const props = {
                labels: labels,
                antiForgeryToken,
                formId,
                formTypeName,
                apiUrl: apiUrl,
                newsletters: newsletters,
                newslettersUserInputs: newslettersUserInputs,
                enableUserTrack: enableUserTrack
            }

            const component = createApp(SignupMultipleNewsletters, props)
                .use(Store)
                .use(VueReCaptcha, { siteKey: recaptchaSiteKey })
            component.mount(SignupMultipleNewslettersDOM)
        })
    }
}
